/* src/app/components/individual-settings/individual-settings.component.scss */
.container {
  padding: 12px;
  gap: 10px;
}
.container .section-container {
  gap: 5px;
}
.container .section-container .section {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #cbcbcb;
}
.lamination img,
.lamination app-cover-thumbnail,
.binding img,
.binding app-cover-thumbnail {
  width: 20px;
  margin-right: 10px;
}
.lamination ion-icon,
.binding ion-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.binding-option {
  height: 35px;
}
.binding-option app-cover-thumbnail {
  height: 100%;
}
.binding-option app-cover-thumbnail svg {
  height: 100%;
}
.file-alias-input {
  padding: 6.5px 5px 6.5px 5px;
  border: 1px solid #949494;
  border-radius: 5px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
}
.file-text {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: black;
}
.file-text.bold {
  font-weight: 500;
}
.blank-sheets div {
  border-radius: 10px;
  padding: 5px;
  background: #f6f6f6;
}
.cover img {
  width: 40px;
  height: 38px;
  margin-right: 10px;
}
.cover ion-button {
  min-height: unset;
}
.cover ion-button::part(native) {
  padding: 0;
}
.cover ion-button ion-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.color ion-radio::part(label) {
  margin-inline-start: 4px;
}
.color ion-radio::part(container) {
  width: 1rem;
  height: 1rem;
}
.color ion-radio.radio-checked::part(container) {
  background: var(--ion-color-primary);
}
.color ion-radio.radio-checked::part(mark) {
  background: white;
}
.laminated-cover ion-checkbox {
  margin: 0 !important;
  --size: 18px;
  --checkbox-background-checked: var(--ion-color-primary);
  --checkmark-width: 3px;
}
.laminated-cover ion-checkbox::part(container) {
  border-radius: 3px;
}
.laminated-cover ion-button {
  min-height: unset;
}
.laminated-cover ion-button::part(native) {
  padding: 0;
}
.laminated-cover ion-button ion-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
  margin-bottom: 3px;
}
ion-card {
  margin: 0;
  padding: 20px;
}
ion-button {
  margin: 0;
  min-height: unset;
}
ion-button::part(native) {
  padding: 12px;
  font-weight: 600;
  border-radius: 10px;
  border-width: 1px;
}
.coverLaminatedTag {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #259dff;
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  background-color: #d4ecff;
}
/*# sourceMappingURL=individual-settings.component-3S6SSAJQ.css.map */
